import { ITelemetry } from '@msdyn365-commerce/telemetry-internal';
import { IRequestContext } from '@msdyn365-commerce/core-internal';
import { useMemo } from 'react';
import { DatalayerService } from '../services/DatalayerService';

export const useDatalayerService = ({ request, telemetry }: { request: IRequestContext; telemetry: ITelemetry }): DatalayerService => {
    return useMemo(() => new DatalayerService(request, telemetry), [request, telemetry]);
};
